import { Component, forwardRef, HostListener } from '@angular/core';
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BehaviorSubject, combineLatest, map, Observable, takeUntil } from "rxjs";
import { FormSelectComponentDirective } from "../../../abstractions/form-select.directive";
import { KeyValue } from "@angular/common";
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'form-select-searchable',
    templateUrl: './form-select-searchable.components.html',
    styleUrls: ['./form-select-searchable.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormSelectSearchableComponent),
            multi: true
        }],
    standalone: false
})
export class FormSelectSearchableComponent extends FormSelectComponentDirective {

  private readonly searchSubject = new BehaviorSubject<string>('');

  get search(): string {
    return this.searchSubject.value;
  }

  set search(value: string) {
    this.searchSubject.next(value);
  }

  get canClear(): boolean {
    return (this.value ?? '') !== '';
  }

  options$: Observable<KeyValue<any, any>[]> = combineLatest([
    toObservable(this.displayOptions),
    this.searchSubject,
  ]).pipe(
    takeUntil(this.destroy$),
    map(([options, search]: [KeyValue<any, any>[], string]) => {
      const normalizedSearch = search.trim().toLowerCase();

      return options
        .filter((option: KeyValue<any, any>) => option.key !== this.value)
        .filter((option: KeyValue<any, any>) => {
          if (!normalizedSearch) {
            return true;
          }

          return option.value.toLowerCase().includes(normalizedSearch);
        });
    })
  );

  @HostListener('click')
  onHostClick(): void {
    this.showOptionList = !this.showOptionList;
  }

  onValueChange(option: KeyValue<any, any>): void {
    this.value = option.key;
    this.showOptionList = false;
    this.search = '';
  }

  onClear(event: Event): void {
    event.stopPropagation();
    this.value = '';
    this.showOptionList = false;
    this.search = '';
  }

}
